import React from 'react';

export function AdvSliderInput({ label, val, set, min, max, unit, step = 1 }) {
  const isActive = val !== null && val !== undefined;
  const displayValue = isActive ? val : min;

  const handleChange = (e) => {
    const value = parseFloat(e.target.value);
    set(value);
  };

  const handleToggle = () => {
    if (isActive) {
      set(null); // Turn OFF
    } else {
      set(min); // Turn ON with minimum value
    }
  };

  return (
    <div className="flex items-center justify-between text-xs">
      <label className="text-zinc-400 w-2/5 flex items-center gap-1">
        <input
          type="checkbox"
          checked={isActive}
          onChange={handleToggle}
          className="w-3 h-3 rounded bg-zinc-700 border-zinc-600 text-blue-500 focus:ring-0 focus:ring-offset-0"
        />
        {label}
      </label>
      <div className="w-3/5 flex items-center gap-2">
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={displayValue}
          onChange={handleChange}
          disabled={!isActive}
          className={`w-full h-1.5 rounded-lg appearance-none cursor-pointer ${
            isActive ? 'bg-zinc-700 accent-blue-500' : 'bg-zinc-800 opacity-30 cursor-not-allowed'
          }`}
        />
        <span className={`font-mono w-16 text-right ${isActive ? 'text-white' : 'text-zinc-600'}`}>
          {isActive ? displayValue.toFixed(step === 1 ? 0 : 1) : '-'}{' '}
          <span className="text-zinc-500">{unit}</span>
        </span>
      </div>
    </div>
  );
}